(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-blanket-boutique"]) return;
  try {
    

if (!customElements.get('wb-blanket-shop')) {
  customElements.define('wb-blanket-shop', class extends HTMLElement {
    async connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.abort = new AbortController();
      this.grid = this.querySelector('.wb-grid');
      this.notice = this.querySelector('.wb-filter-status');
      this.pageSize = Number(this.dataset.pageSize) || 16;
      this.storageKey = 'warmwonders:blanket-wishlist:v1';
      this.saved = new Set();
      this.storageOK = true;
      try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
        if (Array.isArray(saved)) this.saved = new Set(saved.map(String));
      } catch (_) { this.storageOK = false; }
      this.styles = this.parse(this.dataset.styles).map(value => value.trim());
      this.colors = this.parse(this.dataset.colors).map(value => value.trim());
      if (this.normalizeStyleRoute()) return;
      this.readState();
      const styleRow = this.querySelector('.wb-categories');
      if (styleRow) {
        const track = document.createElement('div');
        track.className = 'wb-style-scroll-track';
        track.setAttribute('aria-hidden', 'true');
        const thumb = document.createElement('span');
        track.append(thumb);
        styleRow.after(track);
        const updateTrack = () => {
          const total = styleRow.scrollWidth || 1;
          thumb.style.width = Math.min(100, 100 * styleRow.clientWidth / total) + '%';
          thumb.style.marginLeft = (100 * Math.max(0, styleRow.scrollLeft) / total) + '%';
        };
        styleRow.addEventListener('scroll', updateTrack, {passive:true, signal:this.abort.signal});
        this.styleRowObserver = new ResizeObserver(updateTrack);
        this.styleRowObserver.observe(styleRow);
        updateTrack();
      }
      this.bindCart();
      this.querySelector('.wb-sort-form').addEventListener('change', event => {
        if (event.target.name !== 'sort_by') return;
        const url = new URL(location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        location.assign(url.href);
      });
      this.querySelector('.wb-hero__button')?.addEventListener('click', event => {
        event.preventDefault();
        this.querySelector('.wb-style-heading').scrollIntoView({behavior: this.motion(), block: 'start'});
      });
      try {
        await this.loadCollection();
        if (!this.isConnected) return;
        this.buildFilters();
        this.bindFilters();
        this.querySelector('.wb-filter-controls').hidden = false;
        this.querySelector('.wb-native-pagination').hidden = true;
        this.querySelectorAll('[data-wb-heart]').forEach(button => { button.hidden = !this.storageOK; });
        this.querySelector('.wb-saved-toggle').hidden = !this.storageOK;
        this.render(false, false);
      } catch (error) {
        if (error.name !== 'AbortError') this.notice.textContent = 'Advanced filters could not load. You can still browse the collection or refresh to try again.';
      }
    }
    disconnectedCallback() { this.styleRowObserver?.disconnect(); this.abort?.abort(); window.removeEventListener('popstate', this.onPop); window.removeEventListener('storage', this.onStorage); }
    parse(value) { try { const parsed = JSON.parse(value || '[]'); return Array.isArray(parsed) ? parsed : []; } catch (_) { return []; } }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    readState() {
      const query = new URLSearchParams(location.search);
      this.state = {size: query.get('wb_size') || '', color: query.get('wb_color') || '', style: this.canonicalStyle(query.get('wb_style') || ''), available: query.get('wb_available') === '1', min: query.get('wb_min') || '', max: query.get('wb_max') || '', saved: query.get('wb_saved') === '1'};
      this.page = Math.max(1, Number(query.get('page')) || 1);
    }
    async loadCollection() {
      const pages = Math.max(1, Number(this.dataset.pages));
      const currentPage = Number(this.dataset.page) || 1;
      const byPage = new Map([[currentPage, [...this.querySelectorAll('[data-wb-card]')]]]);
      const queue = Array.from({length: pages}, (_, index) => index + 1).filter(page => page !== currentPage);
      if (queue.length) this.notice.textContent = 'Preparing collection filters…';
      const worker = async () => {
        while (queue.length) {
          const page = queue.shift();
          const url = new URL(location.href);
          url.searchParams.set('page', page);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, {signal: this.abort.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Collection unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const shop = doc.querySelector('wb-blanket-shop');
          if (!shop || Number(shop.dataset.total) !== Number(this.dataset.total)) throw new Error('Collection updated while loading');
          byPage.set(page, [...shop.querySelectorAll('[data-wb-card]')]);
        }
      };
      await Promise.all(Array.from({length: Math.min(3, queue.length)}, worker));
      const unique = new Map();
      [...byPage.entries()].sort((a,b) => a[0] - b[0]).forEach(([,cards]) => cards.forEach(card => unique.set(card.dataset.productId, card)));
      if (unique.size !== Number(this.dataset.total)) throw new Error('Incomplete collection');
      this.cards = [...unique.values()].map(element => ({element, id: element.dataset.productId, tags: this.parse(element.dataset.tags), style: this.primaryStyle(this.parse(element.dataset.tags)), sizes: this.parse(element.dataset.sizes), colors: this.parse(element.dataset.colors), available: element.dataset.available === 'true', price: Number(element.dataset.price)}));
      this.notice.textContent = '';
    }

    primaryStyle(tags) {
      const assigned = this.styles.find(style => tags.some(tag => tag.trim().toLowerCase() === style.toLowerCase()));
      if (assigned) return assigned;
      const seasonal = /^(seasonal|christmas|halloween|fall|autumn|thanksgiving|holiday|holidays)$/i;
      if (tags.some(tag => seasonal.test(tag.trim()))) return 'Seasonal';
      return '';
    }
    canonicalStyle(value) {
      const key = value.trim().toLowerCase();
      const aliases = {victorian:'Victorian & Vintage', floral:'Cozy Cottage', botanical:'Earthy Botanical', nature:'Earthy Botanical', striped:'Modern Farmhouse', stripes:'Modern Farmhouse', gingham:'Modern Farmhouse', checks:'Modern Farmhouse'};
      return aliases[key] || this.styles.find(style => style.toLowerCase() === key || style.toLowerCase().replace(/&/g, '').replace(/\s+/g, '-').replace(/-+/g, '-') === key) || '';
    }
    normalizeStyleRoute() {
      const base = this.dataset.collectionUrl.replace(/\/$/, '');
      const path = location.pathname.replace(/\/$/, '');
      if (!path.startsWith(base + '/')) return false;
      const style = this.canonicalStyle(decodeURIComponent(path.slice(base.length + 1)));
      if (!style) return false;
      const url = new URL(location.href);
      url.pathname = base;
      url.searchParams.set('wb_style', style);
      url.searchParams.delete('page');
      location.replace(url.href);
      return true;
    }
    buildFilters() {
      const existingTags = new Set(this.cards.flatMap(card => card.tags));
      const sizes = [...new Set(this.cards.flatMap(card => card.sizes))];
      const choices = {size: sizes, color: [...new Set([...this.colors.filter(color => existingTags.has(color)), ...this.cards.flatMap(card => card.colors)])], style: this.styles};
      Object.entries(choices).forEach(([type, values]) => {
        const select = this.querySelector(`[data-wb-filter="${type}"]`);
        values.forEach(value => select.add(new Option(value, value)));
        select.closest('label').hidden = !values.length;
      });
      this.querySelectorAll('[data-wb-style]').forEach(link => {
        const style = link.dataset.wbStyle;
        if (!style) return;
        const card = this.cards.find(card => card.style === style);
        const soon = link.querySelector('[data-wb-soon]');
        if (soon) soon.hidden = Boolean(card);
        if (!card) return;
        if (link.dataset.customImage !== 'true') {
          const source = card.element.querySelector('.wb-card__primary');
          let target = link.querySelector('img');
          if (source && !target) {
            target = document.createElement('img'); target.alt = ''; target.loading = 'lazy';
            link.querySelector('.wb-category__image').replaceChildren(target);
          }
          if (source && target) {
            link.querySelector('.wb-category__image').classList.add('wb-category__image--product');
            const url = new URL(source.getAttribute('src'), location.origin);
            url.searchParams.set('width', '900');
            target.src = url.href;
            target.removeAttribute('srcset');
          }
        }
      });
    }
    bindFilters() {
      this.querySelectorAll('[data-wb-filter]').forEach(select => select.addEventListener('change', () => { this.state[select.dataset.wbFilter] = select.value; this.render(true); }));
      this.querySelectorAll('[data-wb-style]').forEach(link => link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        if (location.pathname.replace(/\/$/, '') !== this.dataset.collectionUrl.replace(/\/$/, '')) return;
        event.preventDefault();
        if (link.classList.contains('wb-view-all')) Object.keys(this.state).forEach(key => { this.state[key] = typeof this.state[key] === 'boolean' ? false : ''; });
        else this.state.style = link.dataset.wbStyle;
        this.render(true);
      }));
      this.querySelector('.wb-filter-toggle').addEventListener('click', event => {
        const button = event.currentTarget;
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        this.querySelector('.wb-extra').hidden = !expanded;
      });
      this.querySelector('[data-wb-available]').addEventListener('change', event => { this.state.available = event.target.checked; this.render(true); });
      ['min', 'max'].forEach(type => this.querySelector(`[data-wb-${type}]`).addEventListener('change', event => { this.state[type] = event.target.value; this.render(true); }));
      this.querySelector('.wb-saved-toggle').addEventListener('click', () => { this.state.saved = !this.state.saved; this.render(true); });
      this.addEventListener('click', event => {
        const heart = event.target.closest('[data-wb-heart]');
        if (heart) {
          const card = heart.closest('[data-wb-card]');
          const id = card.dataset.productId;
          const next = new Set(this.saved);
          next.has(id) ? next.delete(id) : next.add(id);
          try { localStorage.setItem(this.storageKey, JSON.stringify([...next])); this.saved = next; this.render(false, false); }
          catch (_) { this.notice.textContent = 'This browser could not save favorites. Please allow local site storage and try again.'; }
        }
        const chip = event.target.closest('[data-wb-remove]');
        if (chip) { const key = chip.dataset.wbRemove; this.state[key] = typeof this.state[key] === 'boolean' ? false : ''; this.render(true); }
        if (event.target.closest('[data-wb-clear]')) {
          Object.keys(this.state).forEach(key => { this.state[key] = typeof this.state[key] === 'boolean' ? false : ''; });
          this.render(true);
        }
      });
      this.onPop = () => { this.readState(); this.render(false, false); };
      window.addEventListener('popstate', this.onPop);
      this.onStorage = event => { if (event.key === this.storageKey) { this.saved = new Set(this.parse(event.newValue).map(String)); this.render(false, false); } };
      window.addEventListener('storage', this.onStorage);
    }
    render(resetPage, updateURL = true) {
      if (resetPage) this.page = 1;
      const state = this.state;
      const matching = this.cards.filter(card => (!state.size || card.sizes.includes(state.size)) && (!state.color || (card.tags.includes(state.color) || card.colors.includes(state.color))) && (!state.style || card.style === state.style) && (!state.available || card.available) && (!state.saved || this.saved.has(card.id)) && (state.min === '' || card.price >= Number(state.min) * 100) && (state.max === '' || card.price <= Number(state.max) * 100));
      const pages = Math.max(1, Math.ceil(matching.length / this.pageSize));
      this.page = Math.min(this.page, pages);
      const visible = matching.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
      const nextElements = visible.map(card => card.element);
      const currentElements = [...this.grid.children];
      if (currentElements.length !== nextElements.length || currentElements.some((element,index) => element !== nextElements[index])) this.grid.replaceChildren(...nextElements);
      this.cards.forEach(card => {
        const heart = card.element.querySelector('[data-wb-heart]');
        heart.hidden = !this.storageOK;
        heart.setAttribute('aria-pressed', String(this.saved.has(card.id)));
        const title = card.element.querySelector('.wb-card__title').textContent.trim();
        heart.setAttribute('aria-label', `${this.saved.has(card.id) ? 'Unsave' : 'Save'} ${title}`);
      });
      this.querySelector('.wb-count').textContent = `${matching.length} ${matching.length === 1 ? 'product' : 'products'}`;
      this.querySelector('.wb-empty').hidden = matching.length > 0;
      const comingSoon = !this.cards.length || (state.style && !this.cards.some(card => card.style === state.style));
      this.querySelector('.wb-empty h2').textContent = comingSoon ? (state.style ? `${state.style} is on its way.` : 'Something cozy is on its way.') : 'No blankets match just yet.';
      this.querySelector('.wb-empty p').textContent = comingSoon ? 'Thoughtful patterns. Comforting layers. Our throws and blankets are taking shape—check back as new designs arrive.' : 'Try a different color, size, or style to find your next cozy layer.';
      this.querySelector('.wb-empty [data-wb-clear]').textContent = comingSoon ? 'Explore all styles' : 'Clear all filters';
      this.querySelector('.wb-empty [data-wb-clear]').hidden = !Object.values(state).some(Boolean);
      this.querySelectorAll('[data-wb-filter]').forEach(select => { select.value = state[select.dataset.wbFilter]; });
      this.querySelector('[data-wb-available]').checked = state.available;
      this.querySelector('[data-wb-min]').value = state.min;
      this.querySelector('[data-wb-max]').value = state.max;
      this.querySelectorAll('[data-wb-style]').forEach(link => link.setAttribute('aria-current', String(link.dataset.wbStyle === state.style)));
      this.querySelector('[data-wb-saved-count]').textContent = this.cards.filter(card => this.saved.has(card.id)).length;
      this.querySelector('.wb-saved-toggle').setAttribute('aria-pressed', String(state.saved));
      this.querySelector('.wb-saved-note').hidden = !state.saved;
      const chips = this.querySelector('.wb-active');
      chips.replaceChildren();
      Object.entries(state).forEach(([key, value]) => {
        if (!value) return;
        const button = document.createElement('button'); button.type = 'button'; button.dataset.wbRemove = key;
        const label = key === 'available' ? 'In stock' : key === 'saved' ? 'Saved' : key === 'min' ? `Min: ${value}` : key === 'max' ? `Max: ${value}` : String(value);
        button.textContent = `${label} ×`; button.setAttribute('aria-label', `Remove ${label} filter`); chips.append(button);
      });
      chips.hidden = !chips.children.length;
      if (chips.children.length) { const clear = document.createElement('button'); clear.type = 'button'; clear.dataset.wbClear = ''; clear.textContent = 'Clear all'; chips.append(clear); }
      const pagination = this.querySelector('.wb-pagination'); pagination.replaceChildren(); pagination.hidden = pages <= 1;
      const addPage = (page, label, current = false) => {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = label; button.setAttribute('aria-label', `Page ${page}`);
        if (current) button.setAttribute('aria-current', 'page');
        button.addEventListener('click', () => { this.page = page; this.render(false); this.querySelector('.wb-shopping').scrollIntoView({behavior: this.motion()}); }); pagination.append(button);
      };
      if (this.page > 1) addPage(this.page - 1, '←');
      for (let page = Math.max(1, this.page - 2); page <= Math.min(pages, this.page + 2); page++) addPage(page, String(page), page === this.page);
      if (this.page < pages) addPage(this.page + 1, '→');
      if (updateURL) {
        const url = new URL(location.href);
        Object.entries(state).forEach(([key,value]) => { value ? url.searchParams.set(`wb_${key}`, value === true ? '1' : value) : url.searchParams.delete(`wb_${key}`); });
        this.page > 1 ? url.searchParams.set('page', this.page) : url.searchParams.delete('page');
        history.pushState({}, '', url);
      }
    }
    bindCart() {
      this.addEventListener('submit', async event => {
        const form = event.target.closest('.wb-add-form');
        if (!form) return;
        event.preventDefault();
        if (form.dataset.busy) return;
        form.dataset.busy = 'true';
        const button = form.querySelector('[type=submit]');
        const message = form.querySelector('.wb-cart-message');
        const original = button.textContent;
        button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = 'Adding…'; message.hidden = true;
        try {
          const data = new FormData(form);
          data.set('sections', 'cart-icon-bubble');
          data.set('sections_url', location.pathname);
          const base = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${base}cart/add.js`, {method:'POST', headers:{'X-Requested-With':'XMLHttpRequest', Accept:'application/json'}, body:data});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'This item could not be added. Please try again.');
          message.textContent = 'Added to your cart.'; message.hidden = false;
          const bubble = document.getElementById('cart-icon-bubble');
          const bubbleHTML = result.sections?.['cart-icon-bubble'];
          if (bubble && bubbleHTML) {
            const section = new DOMParser().parseFromString(bubbleHTML, 'text/html').querySelector('.shopify-section');
            if (section) bubble.innerHTML = section.innerHTML;
          }
        } catch (error) { message.textContent = error.message === 'Failed to fetch' ? 'Connection interrupted. Please check your cart before trying again.' : error.message; message.hidden = false; }
        finally { delete form.dataset.busy; button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = original; }
      });
    }
  });
}



  } catch(e) { console.error(e); }
})();
})();
